import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
//files
import AddSupplierPoRecord from '../../supplierPoAdd';
import Dialog from '@material-ui/core/Dialog';
import RecievedDialog from '../../supplierPoAdd/RecievedDialog';
// Reuse eye button styles for border + hover like other action buttons
import { useStyles as viewStyles } from '../../supplierPoGrn/ViewSupplierPO';

const RecievedButton = (props) => {
  const classes = viewStyles();
  const [open, setOpen] = React.useState(false);
  const [recievedDialog, setRecievedDialog] = React.useState(false);

  const handleClickRecieved = () => {
    setRecievedDialog(true);
  };

  const handleCloseRecieved = () => {
    setRecievedDialog(false);
  };

  const handleClickOpen = () => {
    setRecievedDialog(false);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <CheckIcon
        fontSize='small'
        className={classes.multipleLogo}
        onClick={handleClickRecieved}
        style={{ display: 'inline-flex', verticalAlign: 'middle' }}
      />
      <AddSupplierPoRecord open={open} handleClose={handleClose} {...props} />
      <Dialog
        open={recievedDialog}
        onClose={handleCloseRecieved}
        fullWidth
        maxWidth='xl'
        PaperProps={{ style: { width: '90vw' } }}
      >
        <RecievedDialog
          handleClickOpen={handleClickOpen}
          handleCloseRecieved={handleCloseRecieved}
          {...props}
        />
      </Dialog>
    </React.Fragment>
  );
};

export default RecievedButton;
